/**
 * Show a confirmation dialog. Returns a Promise that resolves to true/false.
 */
const ConfirmDialog = ({ title = 'Confirm', message = 'Are you sure?' } = {}) => {
    return Promise.resolve(window.confirm(`${title}\n\n${message}`));
};

export default ConfirmDialog;
